jQuery(function($) {

  // /* VAR */
  // var LARGEUR_MAX_MOBILE = 800;
  // var header = $("#masthead");
  // var topMenuHeight = 80;
   var l_window = parseInt($(window).width());
  // $admin_bar = false;
  // if($('body').hasClass('admin-bar')) $admin_bar = true;
  // var scroll_comprare = 278;
  // if($admin_bar) scroll_comprare = 270;

/******************************************/
    /********** SCROLL - NAV -----------/
  /******************************************/



  /**********************************/
  /******GALERIE ****/
  /**********************************/

 var tl = gsap.timeline();
 var $topslider = $('.topHome_slider');
    tl.pause();
    tl.from(".top_anim", {duration: 3, rotation: 5, opacity:0, transformOrigin: "50% 50%"}); //percents
    tl.from(".union_l", {duration: 2, rotation: 2, opacity:0, x:3, transformOrigin: "50% 50%"}, "0.3"); //percents
    tl.from(".union_r", {duration: 2, rotation: -2, opacity:0, x:-3,transformOrigin: "50% 50%"},"0.3"); //percents
    tl.from(".letterminus_g", {duration: 1, rotation: 0, opacity:0, y:-3,transformOrigin: "50% 50%"},"<0.1"); //ginon
    tl.from(".letterminus_i", {duration: 1, rotation: 0, opacity:0, y:-3,transformOrigin: "50% 50%"},"<0.1"); //ginon
    tl.from(".letterminus_n1", {duration: 1, rotation: 0, opacity:0, y:-3,transformOrigin: "50% 50%"},"<0.1"); //ginon
    tl.from(".letterminus_o1", {duration: 1, rotation: 0, opacity:0, y:-3,transformOrigin: "50% 50%"},"<0.1"); //ginon
    tl.from(".letterminus_n2", {duration: 1, rotation: 0, opacity:0, y:-3,transformOrigin: "50% 50%"},"<0.1"); //ginon
    tl.from(".letterminus_eta, .letterminus_etb", {duration: 1, rotation: 0, opacity:0, y:3,transformOrigin: "50% 50%"},"<0.1"); //associes
    tl.from(".letterminus_a", {duration: 1, rotation: 0, opacity:0, y:3,transformOrigin: "50% 50%"},"<0.1"); //associes
    tl.from(".letterminus_s1", {duration: 1, rotation: 0, opacity:0, y:3,transformOrigin: "50% 50%"},"<0.1"); //associes
    tl.from(".letterminus_s2", {duration: 1, rotation: 0, opacity:0, y:3,transformOrigin: "50% 50%"},"<0.1"); //associes
    tl.from(".letterminus_o2", {duration: 1, rotation: 0, opacity:0, y:3,transformOrigin: "50% 50%"},"<0.1"); //associes
    tl.from(".letterminus_c1", {duration: 1, rotation: 0, opacity:0, y:3,transformOrigin: "50% 50%"},"<0.1"); //associes
    tl.from(".letterminus_i2", {duration: 1, rotation: 0, opacity:0, y:3,transformOrigin: "50% 50%"},"<0.1"); //associes
    tl.from(".letterminus_ie2", {duration: 1, rotation: 0, opacity:0, y:3,transformOrigin: "50% 50%"},"<0.1"); //associes
    tl.from(".letterminus_s3", {duration: 1, rotation: 0, opacity:0, y:3,transformOrigin: "50% 50%"},"<0.1"); //associes


  $('.topHome_slider').on('init', function(event, slick){
        
    setTimeout(function(){
          tl.play(0); 
      }, 800); 
       
    });

    $(".titlekey").each(function() {
      var count = $(this),
          zero={val:0};
        gsap.to(zero,{delay:count.data("delay"),duration:3,val:count.data("number"),onUpdate:countNumber,ease:Power1.easeOuteaseOut});

        function countNumber() {
          var final = gsap.utils.snap(1, zero.val);
          count.text(final);
        }
  });



//        /***********************************/
//     /*** ANIMATION APPARITION ON SCROOL ****/
// /***********************************/

//   var $collection = $('.SectionInView');
// $collection.each(function () {
//    new Waypoint.Inview({
//       element: this,
//       enter: function(direction) {
//         $(this.element).addClass('to_anim');
//         // console.log(this.element.id + ' enter');
//       },
//       entered: function(direction) {
//         // console.log(this.element.id + ' entered');
//       },
//       exit: function(direction) {
       
//       },
//       exited: function(direction) {
//          $(this.element).removeClass('to_anim');
//         // console.log(this.element.id + ' exited');
//       }
//    });
// });



// gsap.from($('.first_homeu'),{delay:0.1,duration:2,x:-200,rotation:5,opacity:0, ease:Power2.easeOuteaseOut});

  $('.topHome_slider').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     // adaptiveHeight: true,
     arrows: false,
     fade: true,
     autoplay:true,
     autoplaySpeed: 4000,
     focusOnSelect: false,
     pauseOnFocus:false,
     dots:true,
     appendDots: $('.slick-slider-dots-pm'),
  });

    $('.topHome_slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      if(nextSlide == 0){tl.play(-0.5);}
    });
    
     $('.MemberHomeSlide').slick({
         slidesToShow: 1,
         variableWidth: true,
         infinite: true,
         // adaptiveHeight: true,
         arrows: true,
         centerMode: false,
         autoplay:true,
         autoplaySpeed: 2000,
         focusOnSelect: false,
         pauseOnFocus:false,
         dots:false
    });
     
      $('.TeamExpertise-Container').slick({
         slidesToShow: 3,
         variableWidth: false,
         infinite: false,
         // adaptiveHeight: true,
         arrows: true,
         centerMode: false,
         autoplay:true,
         autoplaySpeed: 2000,
         focusOnSelect: false,
         pauseOnFocus:false,
         dots:false,
        responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true
          }
          },
           {
            breakpoint: 360,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true
            }
          }
        ]

    });


      /* Membre de l'équipe dans la page EQUIPE */
      $('.TeamMember-Container').slick({
        slidesToShow: 1,
        responsive: [
            {
              breakpoint: 5000,
              settings: "unslick"
            },
            {
              breakpoint: 768,
              infinite: false,
              arrows: true,
              autoplay:true,
              autoplaySpeed: 2000,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 360,
              infinite: false,
              arrows: true,
              autoplay:true,
              autoplaySpeed: 2000,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
    });

     

     /** Slide prédecesseur / page etude **/
       $('.PredecessorSlide').slick({
         slidesToShow: 1,
         variableWidth: true,
         infinite: true,
         // adaptiveHeight: true,
         arrows: true,
         centerMode: false,
         autoplay:true,
         autoplaySpeed: 2000,
         focusOnSelect: false,
         pauseOnFocus:false,
         dots:false
    });


        
    /* Masonry Expertise archive */  
    var $container_expertise_masonry = $('.ExpertiseMasonry');
    $container_expertise_masonry.imagesLoaded(function () {
        $container_expertise_masonry.masonry({
             itemSelector: '.grid-item',
        columnWidth: '.gridpost-sizer',
        gutter: '.gridpost-gutter-sizer',
        });
    });
   $container_expertise_masonry.masonry({
        itemSelector: '.grid-item',
        columnWidth: '.gridpost-sizer',
        gutter: '.gridpost-gutter-sizer',
       // horizontalOrder: true
    });




/*********************************/
/** TABS EN MODE MOBILE + ACCORDEON SIMPLE, PAR EXEMPLE : AUTRES EXPERTISES **/
/*********************************/


  /* if in drawer mode */
  if(l_window < 1024) $('.to_hide_tablette').hide();
  $(".js-Tabs-Inner-Title").click(function() {
       var parentActiveTab = $(this).parent().attr('data-tabs-id');
      if($(this).next().css('display') == 'none'){
          $(parentActiveTab+" .js-Tabs-Inner-Content").hide();
          var d_activeTab = $(this).attr("rel"); 
          $("#"+d_activeTab).fadeIn();
        
        $(parentActiveTab+" .js-Tabs-Inner-Title").removeClass("d_active");
          $(this).addClass("d_active");
        
        // $(parentActiveTab+" .Tabs-Liste li").removeClass("active"); // inutile pour footer mais utile pour global tabs
        // $(parentActiveTab+" .Tabs-Liste li[rel^='"+d_activeTab+"']").addClass("active");  // inutile pour footer mais utile pour global tabs
    }else{
      $(this).next().slideUp(400);
       $(this).removeClass("d_active");
      // $(parentActiveTab+" .js-Tabs-Inner-Title, .Tabs-Liste li").removeClass("d_active");  // inutile pour footer mais utile pour global tabs
    }
    });



  ////////////////////////////////////////////////////////////////////////////////////////
  ///////
  ///////////////////////////////////////////////////////////////////////////////////////
   /* *****************  */
    /* ACCORDEON
  /* *****************  */

    function init_accordeon(){
      $('.accordion-section-content').hide();
      // manque un truc pour les autres onglets // 
    }
    init_accordeon();

    $('.accordion-section-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('href');
      
         $('.accordion-section-content[data-id!="'+currentAttrValue+'"]').slideUp(300);
         $('.accordion-section-content[data-id!="'+currentAttrValue+'"]').parent().removeClass('active'); 

        if($(this).parent().parent().hasClass('active')) {
          
           // close_accordion_section();
            $('.accordion-section-content[data-id="'+currentAttrValue+'"]').slideUp(300).removeClass('open');
            $(this).parent().parent().removeClass('active');

           // $('.Acc-Item_img[data-id="'+currentAttrValue+'"]').slideUp(300).removeClass('open'); 

        }else {
          //  close_accordion_section();
 
            // Add active class to section title
            $(this).parent().parent().addClass('active');
            // Open up the hidden content panel
            $('.accordion-section-content[data-id="'+currentAttrValue+'"]').slideDown(300).addClass('open'); 
            
        }
 
        e.preventDefault();
    });
    // FIN ACCORDEON //
    ////////////////////
    


    //////
    ///// Etude ////// 

      if ( $( ".box_animImg_trigger" ).length ) {  
      const boxes = gsap.utils.toArray('.box_animImg_trigger');
      boxes.forEach(box => {
          var img = box.querySelectorAll('.BoxImg');
          gsap.from(img, {
          y: 40,
          ease: "none",
          scrollTrigger: {
            trigger:box,
            // start: "top bottom", // the default values
             end: "bottom center",
            scrub: true
          }, 
        });

      });
     }



     const inview = gsap.utils.toArray('.SectionInView');
      inview.forEach((btn) => {
        gsap.from(btn, {
          scrollTrigger: {
            start: 'top bottom',
            end: 'bottom top',
            trigger: btn,
            toggleClass: 'to_anim'
          }
        });
      });



// BACK TO TOP ///
if(l_window > 1024){

$(window).scroll(function() {
    if ($(this).scrollTop() > 1200) {
        $('#toTop').fadeIn(500);
    } else {
        $('#toTop').fadeOut(500);
    }
});

$("#toTop").click(function() {
    $("html, body").animate({scrollTop: 0}, 1000);
 });
}


  // FORM CONTACT LABEL ///

    $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });


    /******************************************/
        /********** Page de maintenance-----------/
    /******************************************/

    $('.sliderGinon').slick({
        autoplay:true,
        autoplaySpeed:5000,
        dots: false,
        arrows:false,
        infinite: true,
        speed: 1500,
        fade: true,
        cssEase: 'linear'
    });
        



});




